import type {CreateExtArgs, EnvironmentContext} from '@wix/document-manager-core'
import type {CompRef} from '@wix/document-services-types'
import {generateAndInjectImages} from './utils'
import {type CommonImageFetchParams, fetchSimilarImageUrls} from './requests'

export const generateSimilarImages = async (
    environmentContext: EnvironmentContext,
    createExtArgs: CreateExtArgs,
    componentPointers: CompRef[]
): Promise<void> => {
    return generateAndInjectImages<CommonImageFetchParams>(
        environmentContext,
        createExtArgs,
        componentPointers,
        (_key, url, width, height) => ({
            width_RunwareFlux: width.toString(),
            height_RunwareFlux: height.toString(),
            userImage: url
        }),
        fetchSimilarImageUrls
    )
}
